// Actions
const CANCEL = 'emit/CANCEL';
const ERROR = 'emit/ERROR';
const EVENT = 'emit/EVENT';
const LOADEND = 'emit/LOADEND';
const SUCCESS = 'emit/SUCCESS';

// Reducer
function reducer(state = {}, action = {}) {

  switch (action.type) {
    case CANCEL:
    case ERROR:
    case EVENT:
    case LOADEND:
    case SUCCESS:
      // Perform action
      return {
        ...state,
        eventStream: [...state.eventStream || [], action.MessageEvent]
      };
    default: return state;
  }
}

// Action Creators
function cancel(payload = {}) {
  const MessageEvent = {
    type: 'ROCKETLOANS_CANCEL',
    payload
  };
  window.parent.postMessage(MessageEvent, '*');
  return { type: CANCEL, MessageEvent };
}
function error(payload = {}) {
  const MessageEvent = {
    type: 'ROCKETLOANS_ERROR',
    payload
  };
  window.parent.postMessage(MessageEvent, '*');
  return { type: ERROR, MessageEvent };
}
function event(payload = {}) {
  const MessageEvent = {
    type: 'ROCKETLOANS_EVENT',
    payload
  };
  window.parent.postMessage(MessageEvent, '*');
  return { type: EVENT, MessageEvent };
}
function loadend(payload = {}) {
  const MessageEvent = {
    type: 'ROCKETLOANS_LOADEND',
    payload
  };
  window.parent.postMessage(MessageEvent, '*');
  return { type: LOADEND, MessageEvent };
}
function success(payload = {}) {
  const MessageEvent = {
    type: 'ROCKETLOANS_SUCCESS',
    payload
  };
  window.parent.postMessage(MessageEvent, '*');
  return { type: SUCCESS, MessageEvent };
}

export const emit = {
  reducer,
  actions: {
    cancel,
    error,
    event,
    loadend,
    success
  }
}
